import { render, staticRenderFns } from "./PortCalls.vue?vue&type=template&id=f5aa8efc&scoped=true&"
import script from "./PortCalls.vue?vue&type=script&lang=js&"
export * from "./PortCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aa8efc",
  null
  
)

export default component.exports